import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
// LAYOUT
import AuthGuard from "./guards/AuthGuard";
import DashboardLayout from "./layouts/DashboardLayout";
import MainLayout from "./layouts/MainLayout";
import FindPassword from "./pages/auth/FindPassword";
import Join from "./pages/auth/Join";
import ResetPassword from "./pages/auth/ResetPassword";
import Bctong from "./pages/Bctong";
import Company from "./pages/Company";
import ErrorPage from "./pages/common/Error";
import Placeholder from "./pages/common/Placeholder";
// COMMON
import Splash from "./pages/common/Splash";
import History from "./pages/History";
import Items from "./pages/Items";
import New from "./pages/New";
import Partners from "./pages/Partners";
import Points from "./pages/Points";

const Loadable = (Component) => (props) => (
  <Suspense fallback={<Splash />}>
    <Component {...props} />
  </Suspense>
);

const Login = Loadable(lazy(() => import("./pages/auth/Login")));
const Users = Loadable(lazy(() => import("./pages/Users")));
const AdminQuotations = Loadable(lazy(() => import("./pages/admin/Quotations")));
const AdminItems = Loadable(lazy(() => import("./pages/admin/Items")));
const AdminCompanyPrice = Loadable(lazy(() => import("./pages/admin/Companies/Price")));
const QuickAdd = Loadable(lazy(() => import("./pages/QuickAdd")));
const DriverDone = Loadable(lazy(() => import("./pages/driver/Main/Done")));
const DriverMain = Loadable(lazy(() => import("./pages/driver/Main")));
const AdminAccounting = Loadable(lazy(() => import("./pages/admin/Accounting")));
const AdminCompanyHistory = Loadable(lazy(() => import("./pages/admin/CompanyHistory")));
const AdminBills = Loadable(lazy(() => import("./pages/admin/Bills")));
const Mypage = Loadable(lazy(() => import("./pages/Mypage")));
const Invoice = Loadable(lazy(() => import("./pages/Invoice")));
const AdminIncomingTax = Loadable(lazy(() => import("./pages/admin/IncomingTax")));
const AdminOutgoingTax = Loadable(lazy(() => import("./pages/admin/OutgoingTax")));
const AdminPriceAnalytics = Loadable(lazy(() => import("./pages/admin/PriceAnalytics")));
const AdminInvoiceHistory = Loadable(lazy(() => import("./pages/admin/InvoiceHistory")));
const AdminInvoice = Loadable(lazy(() => import("./pages/admin/Invoice")));
const Test = Loadable(lazy(() => import("./pages/Test")));
const Dev = Loadable(lazy(() => import("./pages/Dev")));
const AdminCompanies = Loadable(lazy(() => import("./pages/admin/Companies")));
const AdminPartners = Loadable(lazy(() => import("./pages/admin/Partners")));
const Pricing = Loadable(lazy(() => import("./pages/Pricing")));
const AdminNotifications = Loadable(lazy(() => import("./pages/admin/Notifications")));
const AdminInvoiceUnpaid = Loadable(lazy(() => import("./pages/admin/InvoiceUnpaid")));
const AdminPoints = Loadable(lazy(() => import("./pages/admin/Points")));
const AdminPayments = Loadable(lazy(() => import("./pages/admin/Payments")));
const AdminTaxPayments = Loadable(lazy(() => import("./pages/admin/TaxPayments")));
const AdminQuotationDetail = Loadable(
  lazy(() => import("./pages/admin/Quotations/QuotationDetail")),
);
const DistanceCalc = Loadable(lazy(() => import("./pages/admin/DistanceCalc/index.jsx")));
const AdminQuotationsV2 = Loadable(lazy(() => import("./pages/admin/QuotationsV2")));
const ChangeLog = Loadable(lazy(() => import("./pages/ChangeLog")));
const Order = Loadable(lazy(() => import("./pages/Order")));
const AdminOrdersV2 = Loadable(lazy(() => import("./pages/admin/OrdersV2")));
const AdminOrdersFee = Loadable(lazy(() => import("./pages/admin/OrdersFee")));
const AdminAccountingQuick = Loadable(lazy(() => import("./pages/admin/AccountingQuick")));
const AdminAccountingPending = Loadable(lazy(() => import("./pages/admin/AccountingPending")));
const AdminDistancePrice = Loadable(lazy(() => import("./pages/admin/DistancePrice")));
const AdminGiftcards = Loadable(lazy(() => import("./pages/admin/Giftcards")));
const AdminDriverBlacklist = Loadable(lazy(() => import("./pages/admin/DriverBlacklist")));
const AdminDispatchTrend = Loadable(lazy(() => import("./pages/admin/DispatchTrend")));

const AuthDashboard = () => (
  <AuthGuard>
    <DashboardLayout />
  </AuthGuard>
);

// const AuthMain = () => {
//   return (
//     <AuthGuard>
//       <MainLayout />
//     </AuthGuard>
//   );
// };

// const DashboardError = () => {
//   return (
//     <DashboardLayout>
//       <Error />
//     </DashboardLayout>
//   );
// };

// PAGES

const routes = createBrowserRouter([
  {
    path: "",
    element: <AuthDashboard />,
    errorElement: <ErrorPage />,
    children: [
      // { path: "", element: <Dashboard /> },
      { path: "", element: <New /> },
      { path: "new", element: <New /> },
      { path: "new/:id", element: <New /> },
      { path: "mypage", element: <Mypage /> },
      { path: "invoice", element: <Invoice /> },
      { path: "partners", element: <Partners /> },
      { path: "points", element: <Points /> },
      { path: "pricing", element: <Pricing /> },
      { path: "company", element: <Company /> },
      { path: "items", element: <Items /> },
      { path: "history", element: <History /> },
      { path: "bctong", element: <Bctong /> },
      { path: "quick", element: <QuickAdd /> },
      { path: "test", element: <Test /> },
      { path: "dev", element: <Dev /> },
      { path: "change-log", element: <ChangeLog /> },
      { path: "order/:id", element: <Order /> },
    ],
  },
  {
    path: "admin",
    element: <AuthDashboard />,
    errorElement: <ErrorPage />,
    children: [
      // { path: "", element: <Playground /> },
      // { path: "orders", element: <AdminOrders /> },
      { path: "orders", element: <AdminOrdersV2 /> },
      { path: "orders/fee", element: <AdminOrdersFee /> },
      { path: "companies", element: <AdminCompanies /> },
      { path: "company/price/:id", element: <AdminCompanyPrice /> },
      { path: "partners", element: <AdminPartners /> },
      { path: "bills", element: <AdminBills /> },
      { path: "invoice", element: <AdminInvoice /> },
      { path: "invoicehistory", element: <AdminInvoiceHistory /> },
      { path: "invoice/unpaid", element: <AdminInvoiceUnpaid /> },
      { path: "accounting", element: <AdminAccounting /> },
      { path: "accounting/quick", element: <AdminAccountingQuick /> },
      { path: "accounting/pending", element: <AdminAccountingPending /> },
      { path: "history/:companyId", element: <AdminCompanyHistory /> },
      { path: "points", element: <AdminPoints /> },
      { path: "notifications", element: <AdminNotifications /> },
      { path: "payments", element: <AdminPayments /> },
      { path: "tax-payments", element: <AdminTaxPayments /> },
      { path: "pricing", element: <Placeholder /> },
      { path: "items", element: <AdminItems /> },
      { path: "quotations", element: <AdminQuotations /> },
      { path: "quotations-v2", element: <AdminQuotationsV2 /> },
      { path: "quotation/detail", element: <AdminQuotationDetail /> },
      { path: "quotation/detail/:id", element: <AdminQuotationDetail /> },
      { path: "users", element: <Users /> },
      { path: "incomingtax", element: <AdminIncomingTax /> },
      { path: "outgoingtax", element: <AdminOutgoingTax /> },
      { path: "price-analytics", element: <AdminPriceAnalytics /> },
      { path: "distance-calc", element: <DistanceCalc /> },
      { path: "distance-price", element: <AdminDistancePrice /> },
      { path: "giftcards", element: <AdminGiftcards /> },
      { path: "driver-blacklist", element: <AdminDriverBlacklist /> },
      { path: "dispatch-trend", element: <AdminDispatchTrend /> },
    ],
  },
  {
    path: "auth",
    // element: <GuestGuard />,
    errorElement: <ErrorPage />,
    children: [
      { path: "join", element: <Join /> },
      { path: "find-password", element: <FindPassword /> },
      { path: "reset-password", element: <ResetPassword /> },
    ],
  },
  {
    path: "driver",
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: ":id", element: <DriverMain /> },
      { path: "done", element: <DriverDone /> },
    ],
  },
  {
    path: "*",
    element: <AuthDashboard />,
  },
]);

export default routes;
